export const objectInArray = (array, object, field) => {
  return array.some((item) => item[field] === object[field]);
};
